
import { fetchConToken } from "../../../helpers/fetch";
import { AppDispatch } from "../../store";

import { EjercicioState, endLoadingEjercicio, setEjercicios } from "./ejercicioSlice";

export const obtenerEjerciciosModulo = (mid: string) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { curso } = getState().curso;


        try {
            const resp = await fetchConToken(`ejercicio/obtener/${mid}/1`);
            const body = await resp.json();

            if (body.ok) {
                const { ejercicios } = body;
                dispatch(setEjercicios(ejercicios))
                dispatch(endLoadingEjercicio());
                return
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const actualizarEjercicioUsuario = (eid: String, estado: Boolean) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { ejercicios } = getState().ejercicio;
        const { curso } = getState().curso;

        try {
            const resp = await fetchConToken(`ejercicio/actualizar-ejercicio-usuario/${eid}/1`, { estado: estado }, 'PUT');
            const body = await resp.json();

            if (body.ok) {
                const { ejercicioUsuarioActualizado } = body;

                const seccionesActualizada = ejercicios.map((item: any) => (
                    item.eid === eid ?
                        {
                            ...item,
                            estado: ejercicioUsuarioActualizado.estado
                        } : item
                ));

                dispatch(setEjercicios(seccionesActualizada))
            }
        } catch (error) {
            console.log(error)
        }

    }
}


// ADMINISTRADOR
export const crearEjercicio = (ejercicio: object) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { ejercicios } = getState().ejercicio;

        try {
            const resp = await fetchConToken(`ejercicio/crear`, ejercicio, 'POST');
            const body = await resp.json();

            if (body.ok) {
                const { ejercicioCreado } = body;
                const ejerciciosActualizado = [...ejercicios, ejercicioCreado]
                dispatch(setEjercicios(ejerciciosActualizado))
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const eliminarEjercicio = (eid: string) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { ejercicios } = getState().ejercicio;

        try {
            const resp = await fetchConToken(`ejercicio/eliminar/${eid}`, { id: eid }, 'DELETE');
            const body = await resp.json();

            if (body.ok) {
                const { ejercicioEliminado } = body;
                const ejerciciosActualizado = ejercicios.filter((item: EjercicioState) => item.eid !== ejercicioEliminado.eid);
                dispatch(setEjercicios(ejerciciosActualizado))
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const actualizarEjercicio = (ejercicio: EjercicioState) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { eid } = ejercicio; 

        const { ejercicios } = getState().ejercicio;

        try {
            const resp = await fetchConToken(`ejercicio/actualizar/${eid}`, ejercicio, 'PUT');
            const body = await resp.json();

            if (body.ok) {
                const { ejercicioActualizado } = body;

                const ejerciciosActualizado = ejercicios.map((item: EjercicioState) => 
                    item.eid === eid ? ejercicioActualizado : item
                )

                dispatch(setEjercicios(ejerciciosActualizado))
                dispatch(endLoadingEjercicio());
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}